module.exports = __webpack_public_path__ + "img/cad4085.jpg";